import { getSiteUrl } from './siteConfig';
import { normalizeIntakeHostname } from './intakePublicUrl';

/** DNS TXT record host prefix (record is `_nexus-proposal.{yourProposalHostname}`). */
export const PROPOSAL_CUSTOM_HOST_TXT_PREFIX = '_nexus-proposal';

export type ProposalCustomHostFields = {
  proposal_custom_hostname?: string | null;
  proposal_custom_host_verified_at?: string | null;
};

/** Same normalization as intake hostnames. */
export const normalizeProposalHostname = normalizeIntakeHostname;

/** Public https origin for proposal links when custom host is verified; otherwise main app URL. */
export function getProposalPublicOriginFromBusinessRow(
  business: ProposalCustomHostFields | null | undefined,
): string {
  const host = normalizeProposalHostname(String(business?.proposal_custom_hostname ?? ''));
  const verified = Boolean(business?.proposal_custom_host_verified_at);
  if (host && verified) {
    return `https://${host}`;
  }
  return getSiteUrl();
}

export function buildPublicProposalUrl(accessToken: string, publicOrigin: string): string {
  const base = (publicOrigin || getSiteUrl()).replace(/\/$/, '');
  return `${base}/proposal/${accessToken}`;
}
